<template>
  <div class="index_warp">
    <div class="content" v-loading="dataLoading">
      <div class="top-content">
        <div class="top-header">
          <button type="button" class="link-button" @click="toOutSide('share')" v-show="currLang === 'cn'">
            <img class="top-logo" :src="topLogo" alt="中国科技资源共享网" />
          </button>
          <div class="actions">
            <span class="unit-text">{{ currLang === 'cn' ? '共建单位：' : 'Co-construction Units: ' }}</span>
            <button type="button" class="link-button unit-button" aria-label="GemPharmatech" @click="toOutSide('unit_gemtech')">
              <img class="unit-logo" :src="unit_gemtech" alt="GemPharmatech" />
            </button>
            <button type="button" class="link-button unit-button" :aria-label="currLang === 'en' ? 'Yunnan University' : '云南大学'" @click="toOutSide('unit_ynu')">
              <img class="unit-logo" :src="unit_ynu" :alt="currLang === 'en' ? 'Yunnan University' : '云南大学'" />
            </button>
            <button type="button" class="link-button unit-button" :aria-label="currLang === 'en' ? 'Institute of Biophysics, CAS' : '中科院生物物理研究所'" @click="toOutSide('unit_cas')">
              <img class="unit-logo" :src="unit_cas" :alt="currLang === 'en' ? 'Institute of Biophysics, CAS' : '中科院生物物理研究所'" />
            </button>
            <div class="langs">
              <button type="button" class="link-button" lang="zh-CN" @click="langChange('cn')" :class="activeCnBtn" :aria-pressed="currLang === 'cn'">中文（简体）</button>
              ｜
              <button type="button" class="link-button" lang="en" @click="langChange('en')" :class="activeEnBtn" :aria-pressed="currLang === 'en'">
                &nbsp;English
              </button>
            </div>
            <div class="isLogin">
              <div v-if="userInfo.name" class="user-info">
                <button type="button" class="cart-entry link-button" @click="handleCommand('/myIntention')">
                  <img class="cart-icon" :src="cartIcon" :alt="$t('cart')" />
                </button>
                <el-dropdown trigger="hover" @command="handleCommand">
                  <button type="button" class="el-dropdown-link user-name link-button" :aria-label="$t('userCenter') + ': ' + userInfo.name">
                    <span class="user-name-text">{{ userInfo.name }}</span>
                    <img class="dropdown-arrow" :src="arrowIcon" alt="" />
                  </button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="/usercenter">{{ $t('userCenter') }}</el-dropdown-item>
                    <el-dropdown-item command="/dataInfoList">{{ $t('donation') }}</el-dropdown-item>
                    <el-dropdown-item command="/changePwd">{{ $t('changePwd') }}</el-dropdown-item>
                    <el-dropdown-item command="/">{{ $t('logout') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <el-button else class="login-btn" v-else @click="handleMenuListSelect({ router: '/login', key: '' })"> {{
                $t('login') }}</el-button>
            </div>
          </div>
        </div>
        <header class="header">
          <button type="button" class="link-button" :aria-label="$t('home')" @click="handleMenuListSelect({ router: '/', key: '1' })">
            <img class="logo-icon" :src="logo" alt="" />
          </button>
          <el-menu :default-active="activeIndex" mode="horizontal" :router="true">
            <el-menu-item v-for="item in menuItems" :index="item.name" :route="item.path" :key="item.name">
              <p v-if="!item.children">{{ item.name }}</p>
              <el-submenu :index="item.name" v-if="item.children">
                <template slot="title">{{ item.name }}</template>
                <el-menu-item :index="ele.name" :disabled="item.disabled" :route="ele.path"
                  v-for="ele in item.children" :key="ele.name">{{
                    ele.name }}</el-menu-item>
              </el-submenu>
            </el-menu-item>
          </el-menu>
        </header>
      </div>
      <div class="main">
        <keep-alive include="resourceResult">
          <router-view v-if="$route.name === 'resourceResult'"></router-view>
        </keep-alive>
        <router-view v-if="$route.name !== 'resourceResult'"></router-view>
      </div>

      <div class="footer">
        <FooterLink />
        <my-footer @handlerClickHome="
          handleMenuListSelect({ router: '/', key: '1' })
          " @handlerClickLogin="
            handleMenuListSelect({ router: '/login', key: '' })
            " @handlerClickLogout="userLogout"></my-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { handleRequestFailure } from "@/utils/http";
import { loginLocation, clearSessionReturn } from "@/utils/authSession";
import { mapMutations, mapState } from "vuex";
import logo from "../../assets/icon/1.png";
import topLogo from "../../assets/icon/2.png";
import unit from "../../assets/icon/3.png";
import unit_ynu from "../../assets/icon/云南大学logo.png"
import unit_cas from "../../assets/icon/中科院生物物理所.png"
import unit_gemtech from "../../assets/icon/集萃药康logo.jpg"
import icon_footerpin from "../../assets/icon/icon-footerpin.png";
import cartIcon from "../../assets/icon/cart-add.png";
import arrowIcon from "../../assets/icon/arrow.png";
import mixins from "@/mixins/mixins";
import { GetTabTabListApi, logout } from "@/utils/api";
import MyFooter from "@/components/myFooter/myFooter";
import FooterLink from "@/components/FooterLink.vue";
import { file_before_url } from "@/config/baseURL";
export default {
  name: "index",
  components: { MyFooter, FooterLink },
  mixins: [mixins],
  data() {
    return {
      fileBeforeUrl: file_before_url,
      logo, // logo 图标
      topLogo,
      unit_ynu,
      unit_cas,
      unit_gemtech,
      icon_footerpin,
      cartIcon,
      arrowIcon,
      isInit: false,
      currLang: "", // 当前的语言
      dataLoading: false,
      langOptions: [
        {
          value: "cn",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
      ],
      menuOverflow: false, // 菜单栏是否溢出
      menuListPopupVisible: false, // 菜单栏弹窗
      submitList: [], // 子菜单列表
      menuListPopupContentVisible: false,
      currMenuKey: "1",

      homeImageForm: {
        imageUrl_cn: "",
        imageUrl_en: "",
        contactAddress_cn: "",
        contactAddress_en: "",
      },
      menuItems: [
        { name: this.$t('home'), path: "/" },
        {
          name: this.$t('resourceHome'),
          path: "/resourceHome",
          children: [
            { name: this.$t('resourceSearch'), path: "/resourceHome" },
            { name: this.$t('theme'), path: "/subject" },
          ],
        },
        { name: this.$t('newsTitle'), path: "/news" },
        {
          name: this.$t('techService'),
          path: "/techService",
          // children: [
          //   { name: "技术服务", path: "/techService" },
          //   { name: "服务案例", path: "/techService" },
          // ],
        },
        {
          name: this.$t('standardTitle'),
          path: "/standard",
          // children: [
          //   { name: "法律法规", path: "/news" },
          //   { name: "质量标准", path: "/news" },
          // ],
        },
        { name: this.$t('dataRemit'), path: "/dataRemit" },
        { name: this.$t('help'), path: "/help" },
        {
          name: this.$t('about'),
          path: "/about",
          // children: [
          //   { name: "资源库简介", path: "/news" },
          //   { name: "资源库年报", path: "/news", disabled: true },
          // ],
        },
      ],
      activeCnBtn: "active-btn",
      activeEnBtn: "normal-btn",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    name() {
      return localStorage.getItem('name') || ''
    },
    activeIndex() {
      const arr = this.menuItems.filter(
        (item) => item.path === this.$route.path
      );
      return arr?.[0]?.name;
    },
    token() {
      return this.$store.state.token;
    },
    currRoutePath() {
      return this.$store.state.currRoutePath;
    },

  },
  watch: {

  },
  created() {
  },
  async mounted() {
    const lang = localStorage.getItem("lang") || "cn";
    if (lang === "en") {
      this.activeEnBtn = "active-btn";
      this.activeCnBtn = "normal-btn";
      this.currLang = "en";
    } else {
      this.activeCnBtn = "active-btn";
      this.activeEnBtn = "normal-btn";
      this.currLang = "cn";
    }
  },
  methods: {
    ...mapMutations([
      "setCurrLang",
      "setCurrRoutePath",
      "setCurrRouteKey",
      "logout",
      "setMenuList",
    ]),
    handleCommand(command) {
      if (command === '/') {
        logout({}).then(res => {
          this.logout({})
          clearSessionReturn();
          this.$router.push('/login')
          localStorage.removeItem('name')
          localStorage.removeItem('token')
        }).catch(handleRequestFailure)

      } else {
        this.$router.push(command)

      }
    },
    toOutSide(name) {
      let url ="";
      if (name === "share") {
        url = "https://www.escience.org.cn/";
      } else if (name === "unit_gemtech") {
        url = "https://www.gempharmatech.com/"; // 原来的集萃药康
      } else if (name === "unit_ynu") {
        url = "http://www.lac.ynu.edu.cn/.com/"; // 修改为实际网址
      } else if (name === "unit_cas") {
        url = "https://www.ibp.cas.cn/"; // 修改为实际网址
      }
      window.open(url, '_blank');
    },

    /**
     * 切换菜单
     * */
    handleMenuListSelect(obj) {
      let path = obj.router.split("?")[0];
      this.menuListPopupHide();
      if (path === "/login") {
        if (this.$route.path !== "/login") this.$router.push(loginLocation(this.$route.fullPath));
        return;
      }
      const r = window.location.hash.split('#')[1];
      if (r === path) return
      if (this.currRoutePath === path) {
        this.$router.push(obj.router);
        // this.$router.go(0)
        location.reload();
      } else {
        this.setCurrRoutePath({
          currRoutePath: path,
        });
        this.$router.push(obj.router);
      }
    },

    /**
     * 获取url链接中的指定参数
     * */
    getUrlParam(url, name) {
      let param = "";

      if (url.indexOf("?") !== -1) {
        let allParamsStr = url.split("?")[1];
        let allParams = allParamsStr.split("&");
        allParams.forEach((item, index) => {
          let paramArr = item.split("=");
          if (paramArr[0] === name) {
            param = paramArr[1];
          }
        });
      }

      return param;
    },
    /**
     * 语言切换
     * */
    async langChange(e) {
      if (!["cn", "en"].includes(e) || e === (localStorage.getItem("lang") || "cn")) return;
      const english = this.$i18n.locale === "en";
      try {
        await this.$confirm(
          english
            ? "Changing language reloads this page. Unsent forms and chat history may be lost. Continue?"
            : "切换语言会重新加载页面，未提交表单和聊天记录可能丢失。是否继续？",
          english ? "Change Language" : "切换语言",
          {
            confirmButtonText: english ? "Reload and Switch" : "刷新并切换",
            cancelButtonText: english ? "Keep Current Page" : "保留当前页面",
            type: "warning",
          }
        );
      } catch (_) {
        return;
      }
      if (e === "cn") {
        this.activeCnBtn = "active-btn";
        this.activeEnBtn = "normal-btn";
      } else {
        this.activeEnBtn = "active-btn";
        this.activeCnBtn = "normal-btn";
      }
      localStorage.setItem("lang", e);
      this.$i18n.locale = e;
      this.setCurrLang({
        currLang: e,
      });
      this.menuOverflow = false;
      window.location.reload()
    },
    /**
     * 切换菜单栏弹出层是否显示
     * */
    menuListPopupVisibleChange() {
      this.menuListPopupVisible = !this.menuListPopupVisible;
      this.menuListPopupContentVisible = false;
    },
    /**
     * 菜单栏弹出层关闭
     * */
    menuListPopupHide() {
      this.menuListPopupVisible = false;
      this.menuListPopupContentVisible = false;
    },
    /**
     * 菜单栏内容弹出层关闭
     * */
    menuListPopupContentHide() {
      this.menuListPopupContentVisible = false;
    },
    /**
     * 切换菜单栏内容弹出层是否显示
     * */
    menuListPopupContentVisibleChange(arr) {
      this.menuListPopupContentVisible = !this.menuListPopupContentVisible;
      this.submitList = arr;
    },
    /**
     * 退出
     * */
    userLogout() {
      this.logout({});
      clearSessionReturn();
      this.$router.push("/");
      this.$message.success("退出成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.index_warp {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .top-content {
      width: 100%;

      .header {
        border-bottom: 1px solid rgba(235, 238, 245, 1);
      }

      .top-header,
      header {
        padding: 10px 45px;
        height: 70px;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        
        /* 隐藏滚动条但保留滚动功能 */
        &::-webkit-scrollbar {
          display: none;
        }
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }

      .top-header {
        padding: 10px 45px;
        height: 30px;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        background-color: #f7f8fa;

        .top-logo {
          cursor: pointer;
          width: auto;
          height: 16px;
        }
      }

      .actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: auto;

        .unit-text {
          font-size: 14px;
          color: #666;
          margin-right: 8px;
          font-weight: 500;
        }

        .unit-logo {
          height: 24px;
          width: auto;
          margin-right: 15px;
          cursor: pointer;
        }

        .langs {
          align-items: center;
          margin: 0 26px;
          display: flex;

          button {
            cursor: pointer;
            font-size: 14px;
          }

          .active-btn {
            color: #1b72d1;
          }

          .normal-btn {
            color: #999999;
          }
        }

        .lang-change,
        .user-info {
          margin-left: 26px;
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;

          .cart-entry {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #eef3ff;
            cursor: pointer;
            transition: background-color 0.2s ease;

            &:hover {
              background: #dce9ff;
            }

            .cart-icon {
              width: 18px;
              height: 18px;
              object-fit: contain;
            }
          }
        }

        .login-btn {
          width: 76px;
          height: 30px;
          border-radius: 15px 15px 15px 15px;
          border: 1px solid #1b72d1;
          padding: unset;
        }
      }

      header {
        .logo-icon {
          width: auto;
          height: 50px;
          flex-shrink: 0;
        }
      }
    }

    ::v-deep .el-menu {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        white-space: nowrap;
      }

    .user-name {
      color: #333;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;

      .user-name-text {
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .dropdown-arrow {
        width: 8px;
        height: 5px;
        object-fit: contain;
      }
    }

    .el-menu {
        border: none;
        margin-right: -36px;
        background-color: unset;
        flex-shrink: 0;

      .el-submenu__icon-arrow {
        display: none;
      }

      .el-icon-arrow-down:before {
        content: none;
      }

      .el-submenu__title i {
        display: none;
      }

      .el-menu-item,
      ::v-deep .el-submenu__title {
        height: auto;
        line-height: unset;
        padding: 4px 12px !important;
        border: unset;
        color: #303133;
      }

      .el-menu-item>p {
        padding: 4px 12px !important;
        border: unset;
        color: #303133;
      }

      ::v-deep .el-submenu__title:hover {
        background-color: unset;
      }

      .el-menu-item.is-active {
        background-color: #eef3ff;
        border-radius: 4px 4px 4px 4px;
        border: unset;

        p {
          font-weight: 600;
          font-size: 14px;
          color: #1b72d1;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          border: none;
        }
      }
    }

    .main {
      width: 100%;
      flex: 1;
    }

    .footer {
      width: 100%;
    }
  }
}

::v-deep .el-breadcrumb__item {
  >span {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 0.4);

  }
}

::v-deep .el-breadcrumb__item:last-of-type {
  >span {
    font-family: PingFang SC;
    font-weight: 600;
    font-style: Semibold;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 0.9);
  }
}

::v-deep .el-button--primary {
  background-color: #1B72D1;
  border: #1B72D1;
  border-radius: 10px !important;
}

::v-deep .el-button--default {
  border-radius: 10px !important;
}

::v-deep .el-submenu__icon-arrow {
  display: none;
}

::v-deep .el-submenu__title {
  // margin-top: 2px;
}

::v-deep .el-submenu.is-active {
  .el-submenu__title {
    color: #1b72d1 !important;

  }

  font-weight: 600;
  font-size: 14px;

  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  border: none;
}

@media (max-width: 768px) {
  .index_warp .content {
    .top-content {
      .top-header {
        height: auto;
        padding: 10px 16px;
        flex-direction: column;
        align-items: flex-start;

        .top-logo {
          width: 100%;
          height: auto;
          margin-bottom: 10px;
        }

        .actions {
          width: 100%;
          justify-content: space-between;
          flex-wrap: wrap;

          .unit-button, .unit-text {
            display: none; /* Hide unit logo on mobile to save space */
          }

          .langs {
            margin: 0;
          }

          .lang-change, .user-info {
            margin-left: 10px;
          }

          .user-info {
            gap: 8px;
          }
        }
      }

      header {
        height: auto;
        padding: 10px 16px;
        flex-direction: column;
        align-items: flex-start;

        .logo-icon {
          width: 150px;
          height: auto;
          margin-bottom: 10px;
        }

        ::v-deep .el-menu {
          width: 100%;
          overflow-x: auto; /* Allow horizontal scrolling for menu */
          flex-wrap: nowrap;
          margin-right: 0;
          
          .el-menu-item {
            padding: 0 10px !important;
            flex-shrink: 0;
          }
        }
      }
    }
  }
}
</style>
